/**
 * MemberProfile.js - Page profil Membre
 * Utilise le composant ProfilePageModern unifié
 */
import React from 'react';
import ProfilePageModern from './ProfilePageModern';

export default function MemberProfile() {
  return <ProfilePageModern userType="member" />;
}
